/**
 * Format elapsed time in a human-readable format (HH:MM:SS)
 * @param startTime ISO string representing the start time
 * @returns Formatted elapsed time string
 */
export function formatElapsedTime(startTime: string | null | undefined): string {
  if (!startTime) return "00:00:00";
  
  const start = new Date(startTime).getTime();
  const now = new Date().getTime();
  
  // Calculate the difference in seconds
  let seconds = Math.floor((now - start) / 1000);
  
  // Calculate hours, minutes, and seconds
  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  seconds %= 60;
  
  // Format the time as HH:MM:SS
  return [hours, minutes, seconds]
    .map(val => val.toString().padStart(2, '0'))
    .join(':');
}
